import { render, staticRenderFns } from "./RevisionSummary.vue?vue&type=template&id=47bfc450"
import script from "./RevisionSummary.vue?vue&type=script&lang=ts"
export * from "./RevisionSummary.vue?vue&type=script&lang=ts"
import style0 from "./RevisionSummary.vue?vue&type=style&index=0&id=47bfc450&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports